// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cursor-pointer[data-v-72a4ca18]{transition:transform .2s}[dir] .cursor-pointer[data-v-72a4ca18]{cursor:pointer}[dir] .cursor-pointer[data-v-72a4ca18]:hover{transform:translateY(-2px);box-shadow:0 4px 12px rgba(0,0,0,.1)}", ""]);
// Exports
module.exports = exports;
